module.exports = __webpack_public_path__ + "img/PYPL.21639847.png";